/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/co-buys';

export const CoBuyApi = {
  filter: async (option: FilterCoBuyOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filterWithCollaborator: async (option: FilterCoBuyOptions) => {
    let url = `${pathname}/filter-with-collaborator`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCount: async (option: any) => {
    let url = `${pathname}/count`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCoBuyCodeIsExisted: async (code: any) => {
    const url = `${pathname}/check-co-buy-code-is-existed/${code}`;
    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterCoBuyOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityIDs?: string[];
  status?: number;
}
